import { PRE_SIGNUP_ERR } from '../constants/auth';

export const handleRegisterErrMessage = (msg) =>
  msg.replace(PRE_SIGNUP_ERR, '');
